import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { PainAgitation } from './components/PainAgitation';
import { Revelation } from './components/Revelation';
import { Testimonials } from './components/Testimonials';
import { ValueStack } from './components/ValueStack';
import { Faq } from './components/Faq';
import { Guarantee } from './components/Guarantee';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-ink font-sans text-bone" data-id="element-0" data-mp="31aqeoda66opo">
      <UrgencyBar data-id="element-1" data-mp="31c9tdzg6grpc" />
      <Hero data-id="element-2" data-mp="31ctf7r8y808n" />
      <main data-id="element-3" data-mp="2wk0a329kipw1">
        <Hook data-id="element-4" data-mp="2wka0gqyiyz29" />
        <PainAgitation data-id="element-5" data-mp="2wjqgz5t882m4" />
        <Revelation data-id="element-6" data-mp="2wj8fnurpiy7c" />
        <Testimonials data-id="element-7" data-mp="2whx8rm2ytac0" />
        <ValueStack data-id="element-8" data-mp="28ufoebm15ej2" />
        <Faq data-id="element-9" data-mp="28tmex2vosax8" />
        <Guarantee data-id="element-10" data-mp="28te3lff7pdo5" />
        <FinalCta data-id="element-11" data-mp="28surifc8tji1" />
      </main>
      <Footer data-id="element-12" data-mp="23vcjcr61v8b3" />
    </div>;
}